import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TagTemplate, TagTemplateDTO } from 'src/app/_model/tag-template';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { TagTemplatesDaoService } from '../../dao/tag-templates-dao.service';
import { TagTemplatesService } from '../tag-templates.service';

@Injectable()
export class TagTemplatesLogicService implements TagTemplatesService {
  templates$ = new BehaviorSubject<TagTemplate[]>([]);

  constructor(private logger: LoggingService,
    private tagTemplatesDaoService: TagTemplatesDaoService) { }

  async updateTagTemplates(tagTemplatesDto: TagTemplateDTO[]) {
    this.logger.log(this.constructor.name, '- Received new tagtemplates from other IMS component', tagTemplatesDto);

    try {
      const tagTemplates: TagTemplate[] = [];
      tagTemplatesDto?.forEach(tagTemplateDto => {
        tagTemplates.push(TagTemplate.fromDto(tagTemplateDto));
      });
      await this.tagTemplatesDaoService.saveTagTemplates(tagTemplates);
    } catch (error) {
      this.logger.error(this.constructor.name, 'Error parsing TagTemplates: ', error.message);
      throw error;
    }
  }

  reset() {
    this.tagTemplatesDaoService.reset();
  }

  clear() {
    this.tagTemplatesDaoService.clear();
  }
}
